import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo-dark.png'


const _withScopeId = n => (_pushScopeId("data-v-f9764fd2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "maintenance-page",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "maintenance-brand" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "蓝迪云"
  }),
  /*#__PURE__*/_createElementVNode("span", null, "蓝迪云")
], -1))
const _hoisted_3 = { class: "maintenance-card" }
const _hoisted_4 = {
  class: "maintenance-icon",
  "aria-hidden": "true"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "maintenance-tag" }, [
  /*#__PURE__*/_createElementVNode("span"),
  /*#__PURE__*/_createTextVNode(" 服务升级中")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "maintenance-footnote" }, "维护完成后页面将自动恢复，无需重复操作。", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "maintenance-decoration decoration-one" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "maintenance-decoration decoration-two" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ToolOutlined = _resolveComponent("ToolOutlined")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ToolOutlined)
      ]),
      _hoisted_5,
      _createElementVNode("h1", null, _toDisplayString(_ctx.config.title), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.config.message), 1),
      _createVNode(_component_a_button, {
        class: "refresh-button",
        loading: _ctx.checking,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('refresh')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 重新检查 ")
        ]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_a_button, {
        class: "refresh-button",
        style: {"margin-left":"12px"},
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('tester-login')))
      }, {
        default: _withCtx(() => [
          _createTextVNode("测试人员入口")
        ]),
        _: 1
      }),
      _hoisted_6
    ]),
    _hoisted_7,
    _hoisted_8
  ]))
}